import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { TableFooter as MuiTableFooter, TablePagination, TablePaginationActions, TableRow } from '@mui/material';
import React from 'react';
import { useMissionsTranslation } from '../../hooks';
export const TableFooter = ({ page, rowsPerPage, columnSpan, showBorders, rowSpan, rowsPerPageOptions, onPageChange, onRowsPerPageChange, }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(MuiTableFooter, null,
        React.createElement(TableRow, null,
            React.createElement(TablePagination, { sx: { borderBottom: showBorders ? 0 : `1px solid ${themeColors.border.main}` }, rowsPerPageOptions: rowsPerPageOptions, colSpan: columnSpan, count: rowSpan, rowsPerPage: rowsPerPage, page: page, SelectProps: {
                    inputProps: {
                        'aria-label': t('ariaLabels.rowsPerPage'),
                    },
                    native: true,
                }, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, ActionsComponent: TablePaginationActions }))));
};
